// src/pages/PDFViewerPage.jsx
// import React from "react";
import React, { useState, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

export default function PDFViewerPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const pdfUrl = state?.pdfUrl;
  const title = state?.title || "Document";
    const [isLoading, setIsLoading] = useState(true);


   // ── Scroll to top when page loads ──
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!pdfUrl) {
    return (
      <div className="container text-center mt-5">
        <p>No PDF found.</p>
        <button className="btn btn-primary" onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>

      {/* ── HEADER ── */}
      <header style={{ background: "#0b2747", color: "#fff", padding: "12px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h5 className="mb-0">📰 {title}</h5>
        <button className="btn btn-sm btn-danger" onClick={() => navigate(-1)}>
          ✕ Close
        </button>
      </header>

      {/* ── LOADING OVERLAY ── */}
      {isLoading && (
        <div style={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 10,
        }}>
          <div
            className="spinner-border"
            role="status"
            style={{ width: "3rem", height: "3rem", color: "#0b2747" }}
          />
          <p className="mt-3 fw-semibold" style={{ color: "#0b2747" }}>
            Loading PDF, please wait...
          </p>
        </div>
      )}

      {/* ── PDF IFRAME ── */}
      {/* <iframe
        src={pdfUrl}
        title="PDF Viewer"
        style={{ flex: 1, border: "none", width: "100%", height: "calc(100vh - 110px)" }}
      /> */}
      <iframe
  src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(pdfUrl)}`}
  title="PDF Viewer"
  onLoad={() => setIsLoading(false)}
  style={{
    flex: 1,
    border: "none",
    width: "100%",
    height: "calc(100vh - 56px)",
  }}
/>

      {/* ── FOOTER ── 
      <footer style={{ background: "#0b2747", color: "#fff", padding: "10px 24px", textAlign: "center", fontSize: "0.85rem" }}>
        © {new Date().getFullYear()} Porvaall — All rights reserved
      </footer>
*/}
    </div>
  );
}
